import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../app.component';
import {cloneDeep} from "lodash";

@Component({
	selector: 'app-modal-inscription',
	templateUrl: './modal-inscription.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./modal-inscription.component.less']
})
export class ModalInscriptionComponent implements OnInit {
	globalTxt: any;
	modalsTxt: any;
	modalInfo: any;

	constructor(public app: AppComponent,) {
	}

	ngOnInit(): void {
		this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
			console.log("modalInfo  => ", modalInfo);
			this.modalInfo = modalInfo;
		});

		this.getInfosInit();
	}

	getInfosInit() {
		// Get the global texts
		this.app.dataInitService.getGlobalTextsOnce(globalTxt => {
			this.globalTxt = globalTxt;

			// Get the modal texts
			this.app.dataInitService.getModalTextsForModalComponentOnce(modalsTxt => {
				this.modalsTxt = modalsTxt.addUser;
			});
		});
	}
}
